import { NOTES_HEADER_KEYS, NOTES_RECORD_KEYS } from '.';
import { TableColumnConfig } from '../../ui/customTable/Table';

export const notesTableHeaders: TableColumnConfig<any>[] = [
  {
    key: NOTES_RECORD_KEYS.AGENT,
    header: NOTES_HEADER_KEYS.AGENT,
    render: (data) => {
      return <div className="gbmask">{data?.split('@')?.[0]}</div>;
    },
  },
  { key: NOTES_RECORD_KEYS.DATE_TIME, header: NOTES_HEADER_KEYS.DATE_TIME },
  {
    key: NOTES_RECORD_KEYS.NOTES,
    header: NOTES_HEADER_KEYS.NOTES,
    render: (data) => {
      return <div className="gbmask">{data}</div>;
    },
  },
];
